import React from 'react';
import { Icon } from '../icon/Icon';
import './Chip.scss';

interface ChipProps {
  disabled?: boolean;
  iconName?: string;
  label: string;
  handleRemoveChip?: () => void;
}

export const Chip: React.FC<ChipProps> = ({
  disabled,
  iconName,
  label,
  handleRemoveChip
}) => {
  const handleRemove = () => {
    try {
      if (handleRemoveChip) {
        handleRemoveChip();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    try {
      if (e.key === ' ') {
        handleRemove();
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <button
      className={`ads-chip ${handleRemoveChip ? 'ads-chip__close' : ''} ${
        iconName ? 'ads-chip__icon' : ''
      } ${disabled ? 'ads-chip__disabled' : ''}`}
      tabIndex={disabled ? -1 : 0}
      aria-disabled={disabled && true}
      aria-label={`remove ${label} filter`}
      data-testid="ads-chip"
      onKeyDown={(e) => handleKeyDown(e)}
      onClick={handleRemoveChip && handleRemove}
    >
      {iconName && (
        <span className="ads-chip__with-icon">
          {disabled ? (
            <Icon name={iconName} color="ads-color-disabled" />
          ) : (
            <Icon name={iconName} data-testid="ads-chip__icon" />
          )}
        </span>
      )}
      {label}
      {handleRemoveChip && (
        <span className="ads-chip__close-button">
          {disabled ? (
            <Icon name="closeSm" color="ads-color-disabled" />
          ) : (
            <Icon name="closeSm" />
          )}
        </span>
      )}
    </button>
  );
};
